export default {
  needUpdate: async () => ({ isNeeded: false, latestVersion: '', storeUrl: '' }),
  getCurrentVersion: () => '1.0.0',
  getLatestVersion: async () => '1.0.0',
  getCountry: async () => 'US',
  getStoreUrl: async () => '',
};
